import DocumentForm from './DocumentForm';

export default function AdminDocumentFrame() {
    return <DocumentForm />;
}
